import React from "react";
import {ConvertToJalali} from "../../Customer/CustomerServices";
import SimpleLineIcon from "react-simple-line-icons";


function numberWithCommas(x) {
    // convert To toman
    // x= (x/10).toFixed(0)
    //add commas
    if(x){
        x= Math.round(x)
        return x?x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):0;
    }else {
        return "0"
    }
}

function FactorSec ({factor,gotoHome,showGiftSection}){
    return(
        <div className="factor-sec">

            <div className="factor-titre">
                <span>صورت حساب</span>
            </div>



            <div className="factor-header">
                <div className="factor-header-item left">
                    <span className="factor-header-item-title">تاریخ</span>
                    {factor.created?<span className="factor-header-item-val">{ConvertToJalali(factor.created)}</span>:null}
                </div>
                <div className="factor-header-item right">
                    <span className="factor-header-item-title" >شماره فاکتور</span>
                    {factor.uid?<span className="factor-header-item-val">{factor.client_invoice_id || factor.uid}</span>:null}
                </div>
            </div>

            <div className="factor-table">

                <table id="factor-table-invoice">
                    <thead>
                    <tr>
                        <th className="product-table-head">جمع کل</th>
                        {/*<th className="product-table-head">تخفیف</th>*/}
                        <th className="product-table-head">تعداد</th>
                        <th className="product-table-head product-table-head-name">نام کالا</th>
                        {/*<th className="product-table-head product-table-head-name">تصویر</th>*/}
                    </tr>
                    </thead>
                    <tbody>
                    {factor.products && factor.products.map(product=>{
                        return(
                            <tr key={product.uid}>
                                <td className="product-price">{numberWithCommas(product.payable_amount)}</td>
                                {/*<td className="product-count">{numberWithCommas(product.per_discount)}</td>*/}
                                <td className="product-count">{product.quantity}</td>
                                <td className="product-name">{product.product.name}</td>
                                {/*<td className="product-name">*/}
                                {/*    {product.product?<img src={product.product.image?product.product.image:"/other/skeleton/product.jpg"} alt=""/>:null}*/}
                                {/*</td>*/}
                            </tr>
                        )
                    })
                    }
                    </tbody>
                </table>

                <table id="factor-table-total">
                    <thead>
                    <tr>
                        <th className="product-table-head"></th>
                        <th className="product-table-head"></th>
                        <th className="product-table-head product-table-head-name"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr key={5345345}>
                        <td className="product-price discount-label"><span>{factor && numberWithCommas(factor.discount_amount_sum)}</span><span> ریال </span></td>
                        <td className="product-count">{""}</td>
                        <td className="product-name">{" : تخفیف  "}</td>
                    </tr>
                    <tr key={5345345}>
                        <td className="product-price total-label-value"><span>{factor && numberWithCommas(factor.payable_amount)}</span><span> ریال </span></td>
                        <td className="product-count">{""}</td>
                        <td className="product-name total-label">{" : جمع کل  "}</td>
                    </tr>
                    </tbody>
                </table>


            </div>

            {showGiftSection?<div className="gift-section">
                <div className="gift-section-header">
                    <span>پاداش شما از این خرید</span>
                </div>


                <div className="gift-section-ticket">
                    <div className="gift-section-ticket-off">
                        <span className="gift-section-ticket-off-number"><span className="off-number">۳۰</span>%</span>
                        <span className="gift-section-ticket-off-label">تخفیف</span>
                    </div>
                    <div className="gift-section-ticket-info">
                        <div className="rotated-half-up-circle"></div>
                        <div className="rotated-half-down-circle"></div>
                        <span className="gift-section-ticket-info-title">محصولات گوشتی</span>
                        <span className="gift-section-ticket-info-max">تا سقف 50  ریال</span>
                        <div className="gift-section-ticket-info-date">
                            <span>۹۸/۱۲/۳۰</span>
                            <SimpleLineIcon name="clock" />
                        </div>
                    </div>
                </div>

            </div>:null}


            {/*<div className="offer-section">*/}
            {/*    <div className="offer-section-titre">*/}
            {/*        <span>پیشنهادات</span>*/}
            {/*    </div>*/}
            {/*    /!*<div className="swiper-container swiper1">*!/*/}
            {/*    /!*    <div className="swiper-wrapper">*!/*/}
            {/*    /!*        <div className="swiper-slide"><img src="/other/opal4.jpg"/></div>*!/*/}
            {/*    /!*        <div className="swiper-slide"><img src="/other/opal3.jpg"/></div>*!/*/}
            {/*    /!*    </div>*!/*/}
            {/*    /!*</div>*!/*/}
            {/*</div>*/}


            {/*DISABLE SEE MORE FOR PHASE ONE*/}

            {/*{ factor && factor.merchant  ?<div className="top-float-send-btn">*/}
            {/*    <div className="float-btn" onClick={()=>gotoHome()}>*/}
            {/*        <i className="fa fa-angle-left"></i>*/}
            {/*        <span>{factor.merchant.see_more?factor.merchant.see_more:"بیشتر afsd ببینید"}</span>*/}
            {/*    </div>*/}
            {/*</div>:null}*/}

        </div>
    )
}

export {FactorSec};
